import { Navigate } from "react-router-dom";

const Analyses = () => <Navigate to="/dashboard/director/cashflow" replace />;

export default Analyses;
